import { render, staticRenderFns } from "./home_video.vue?vue&type=template&id=29b851e7&scoped=true"
import script from "./home_video.vue?vue&type=script&lang=js"
export * from "./home_video.vue?vue&type=script&lang=js"
import style0 from "./home_video.vue?vue&type=style&index=0&id=29b851e7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b851e7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/crmeb/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29b851e7')) {
      api.createRecord('29b851e7', component.options)
    } else {
      api.reload('29b851e7', component.options)
    }
    module.hot.accept("./home_video.vue?vue&type=template&id=29b851e7&scoped=true", function () {
      api.rerender('29b851e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobilePage/home_video.vue"
export default component.exports